import { useTranslation } from 'next-i18next'
import { FunctionComponent } from 'react'
import { useConsumerSizes } from '../../../../utils/responsive'
import { Heading, Skeleton, useIsCashTheme } from '@afterpaytouch/core'
import { Greeting } from '../../Greeting'

const I18N_NAMESPACE = ['common', 'index']

interface UnsuitabilityProps {
  consumer: { givenName: string; isVerified: boolean }
  isSkeletonShown: boolean
}

export const Unsuitability: FunctionComponent<UnsuitabilityProps> = ({ consumer, isSkeletonShown }) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { headingSize } = useConsumerSizes()
  const isCashTheme = useIsCashTheme()
  return (
    <>
      <div className='flex flex-col'>
        <Greeting consumer={consumer} isLoading={isSkeletonShown} />
        <div className='relative max-w-max'>
          {isSkeletonShown && <Skeleton kind={isCashTheme ? 'Default' : 'Primary'} />}
          <div className={isSkeletonShown ? 'invisible' : 'visible'}>
            <Heading size={headingSize}>
              <span className='block'>{t('index:welcome:unsuitability:heading')}</span>
              {t('index:welcome:unsuitability:subheading')}
            </Heading>
          </div>
        </div>
      </div>
    </>
  )
}
